import styled from 'styled-components'
import { colors } from '../../../../../styles/constants'

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  border-radius: 16px;
  padding: 16px;
  align-items: center;
  align-self: stretch;
  background-color: #F8F9FA;
  flex: 1;
`
export const WrapperClinic = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

`
export const WrapperText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`
export const WrapperVets = styled.div`
  display: flex;
  gap: 16px;
`
export const Vet = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 58px;
  height: 52px;
`
export const VetName = styled.p`
  height: 16px;
  color: ${colors.gray.darker};
  text-align: center;
  font-family: Open Sans;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
`
export const ClinicName = styled.p`
  color: ${colors.gray.darker};
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 19.2px;
  margin: 0;
`
export const Text = styled.p`
  color: ${colors.gray.darker};
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
`

export const Tooltip = styled.div`
  position: relative;
  display: inline-block;

  &:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }
`

export const TooltipText = styled.span`
  visibility: hidden;
  width: 70px;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
  top: 125%;
  margin-left: -10px;
  opacity: 0;
  transition: opacity 0.3s;
`

export const TooltipItem = styled.p`
  font-size: 14px;
  margin: 0;

`
